<div class="status-modal" [hidden]="!visible">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">

      </div>
      <div class="modal-body">
        <div class="loader"></div>
      </div>
      <div class="modal-footer">

      </div>
    </div>
  </div>
</div>